// Developer: Ankit Gupta
import React from 'react';
import { createRoot } from 'react-dom/client';
// Before App, so the first render already has its language and direction.
import './i18n';
import App from './App';

// Global styles
import 'antd/dist/reset.css';
import './styles/theme.css';
import './styles/polish.css';
import './styles/rtl.css';

const container = document.getElementById('root');

if (!container) {
  throw new Error(
    'Root element #root not found. Check your index.html.',
  );
}

const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
